import { QueryParams } from './urls';

export const keys = {
  all: ['contacts'] as const,
  lists: () => [...keys.all, 'list'] as const,
  list: (filters: Partial<QueryParams>) =>
    [...keys.lists(), { filters }] as const,
  relatedList: (id: number | string, filters: Partial<QueryParams>) =>
    [...keys.lists(), { filters }, id, 'matter'] as const,
  details: () => [...keys.all, 'detail'] as const,
  detail: (id: number) => [...keys.details(), id] as const,
  fieldMap: (id: number, fields: string[]) =>
    [...keys.detail(id), { fields }] as const,
};
